import { useApi } from './apiService';

export const useSoftwareInventory = () => {
  const api = useApi();

  const getSoftwareAssets = async (tenantId: string, softwareId: string, pageNumber: number, pageSize: number, searchTerm?: string) => {
    try {
      const queryParams = new URLSearchParams({
        pageNumber: pageNumber.toString(),
        pageSize: pageSize.toString(),
      });

      if (searchTerm?.trim()) queryParams.append('search', searchTerm.trim());

      const response = await api.get(
        `assetmgtservice/SoftwareAssetInventory/${tenantId}/software-asset-by-agent/${softwareId}?${queryParams}`,
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching software assets:', error);
      throw error;
    }
  };

  const getSoftwareAssetsBySoftwareName = async (
    tenantId: string,
    softwareName: string,
    pageNumber: number,
    pageSize: number,
    searchTerm?: string,
  ) => {
    try {
      const response = await api.get(`assetmgtservice/SoftwareAssetInventory/${tenantId}/software-asset-by-agent`, {
        params: {
          softwareName,
          pageNumber,
          pageSize,
          ...(searchTerm?.trim() ? { search: searchTerm.trim() } : {}),
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching software assets by software name:', error);
      throw error;
    }
  };

  // banner api
  const getSoftwareSummary = async (tenantId: string, softwareAssetInventoryId: string) => {
    try {
      const response = await api.get(
        `assetmgtservice/SoftwareAssetInventory/${tenantId}/software-asset-summary/${softwareAssetInventoryId}`,
      );

      return response.data.data;
    } catch (error) {
      console.error('Error fetching software summary:', error);
      throw error;
    }
  };

  const getSoftwareInventorySummary = async (tenantId: string, softwareName: string) => {
    try {
      const response = await api.get(`assetmgtservice/SoftwareAssetInventory/${tenantId}/software-asset-inventory-summary`, {
        params: {
          softwareName: softwareName,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching software inventory summary:', error);
      throw error;
    }
  };

  return { getSoftwareAssets, getSoftwareAssetsBySoftwareName, getSoftwareSummary, getSoftwareInventorySummary };
};
